import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-header-event',
  templateUrl: './header-event.component.html',
  styleUrls: ['./header-event.component.scss']
})
export class HeaderEventComponent implements OnInit {

  @Input() headerData: any;
  public isLinkEsternal: boolean = false;

  constructor(
    private nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.isLinkEsternal = this.headerData.labelLinkUrl ? this.nodeService.verifyLinkExternal(this.headerData.labelLinkUrl) : false;
  }

}
